
import React from "react";
import { Grid } from "@mui/material";

import { Formik, Form, FormikConfig } from "formik";
import * as yup from "yup";
import { InputWithErrorLabel } from "components/haven-design/form/inputs";
import { SubmitButton } from "components/buttons";
import { validateEmail } from "utils/validators/email";

const EMAIL_PLACE_HOLDER = "Enter a Default Property Email";
const ORG_EMAIL_PLACE_HOLDER = "Enter a Default Organization Email";

const ccEmailSchema = yup.object({
  email: yup
    .string()
    .nullable()
    .test(
      "is-trim",
      "Should not contain spaces",
      (value) => {
        if (value === null) return true;
        if (typeof value === "undefined") return true;
        return (value.trim() === value);
      },
    )
    .email()
    .trim()
    .test(
      "is-email",
      "Is not a valid email",
      (value) => {
        if (value === null) return true;
        if (typeof value === "undefined") return true;
        return validateEmail(value);
      },
    ),
});
type CCProps = {
  initialEmail: string;
  onSubmit: FormikConfig<{email: string}>["onSubmit"],
  type?: "organization" | "property";
  label?: string;
  placeholder?: string;
}
export const CCEmailForm: React.FC<CCProps> =
({ initialEmail, onSubmit, type = "property", label, placeholder }) =>
  <Formik
    initialValues={{ email: initialEmail }}
    enableReinitialize
    validationSchema={ccEmailSchema}
    onSubmit={onSubmit}>
    {({ isValid }) => (
      <Form>
        <Grid container spacing={2}>
          <Grid size={{ xs: 8, sm: 9, md: 10 }}>
            <InputWithErrorLabel
              margin="none"
              placeholder={placeholder ?? (type === "property" ? EMAIL_PLACE_HOLDER : ORG_EMAIL_PLACE_HOLDER)}
              name="email"
              label={label ?? (type === "property" ? "Property Email" : "Organization Email")}
              type="text"
            />
          </Grid>
          <Grid size={{ xs: 2 }} alignContent="center">
            <SubmitButton text="Save" isWide disabled={!isValid} />
          </Grid>
        </Grid>
      </Form>
    )
    }
  </Formik>;
